import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../core/services/authentication.service';
import { EventsHubService } from '../../core/events-hub.service';
import { ItemMenu } from '../../shared/models';
import { CONFIG } from '../../config';
import { MENU } from '../../shared/menu';


@Component({
  standalone: false,
  selector: 'xform-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public loggedIn: boolean;
  public defaultProfileImage: string;
  public isMenuOpen: boolean;
  public menu: Array<ItemMenu>;
  public userEmail: string = '';

  constructor(
    private authenticationService: AuthenticationService,
    private eventsHubService: EventsHubService,
  ) {
    this.defaultProfileImage = CONFIG.defaultProfileImage;
    this.isMenuOpen = false;
    this.eventsHubService.isMenuOpen$.subscribe(
      (response) => this.isMenuOpen = response
    );
  }

  ngOnInit() {
    this.loggedIn = this.authenticationService.isLoggedIn();
    this.eventsHubService.isLoggedIn$.subscribe(
      (loggedIn) => {
        this.loggedIn = (loggedIn);
        this.userEmail = this.authenticationService.getUserEmail();
      });
    this.menu = MENU;
  }


  public logout() {
    this.authenticationService.logout();
  }

  public openMenu(value: boolean) {
    this.eventsHubService.setMenuState(value);
  }
}
